import React from 'react';

import { Box, Card, H2, Separator, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../../../features/track';
import { urlBuilder } from '../../../../Shared/urlBuilder';

export const TaxSavingsDisabledCard: React.FC = () => {
  const handleTlhInactiveExploreClick = () => {
    trackClick({
      name: 'tlhInactiveExplore',
      module: 'Performance',
      location: 'TaxSavingsCard',
    });
  };

  return (
    <Card>
      <Card.Header css={{ padding: 'space.300' }}>
        <H2 variant="title200">Tax-loss harvesting could lower your tax bill</H2>
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content css={{ padding: 'space.300', display: 'flex', flexDirection: 'column', gap: 'space.200' }}>
        <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.50' }}>
          <Text>
            Nearly 70% of customers using our tax-loss harvesting features had their taxable advisory fee covered by
            likely tax savings.
          </Text>
          <SambaAutoLink
            to={urlBuilder.appTlhSetupSuitabilityIntroduction.absolute()}
            variant="textPrimary"
            onClick={handleTlhInactiveExploreClick}
          >
            See if it's right for you
          </SambaAutoLink>
        </Box>
      </Card.Content>
    </Card>
  );
};
